module.exports = __webpack_public_path__ + "img/5.98d3bbe0.jpg";